export const USERID_CLAIMS =
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata";
